import { Dispatch, SetStateAction } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { UserKeys } from '../../../api/users-api';
import {
  UserRoles,
  isAbleToSeeUIElement,
} from '../../../utils/roles/client-roles';
import SharedGridStateIconButton from '../../../shared/shared-grid-state-icon-button-latest';
import { ModuleList } from '../../../shared/analytics/module-list';
import SharedToolbar from '../../../shared/shared-toolbar-latest';
import SharedIconButton from '../../../shared/buttons/shared-icon-button';
interface UsersGridToolbarProps {
  paginationModel: {
    pageSize: number;
    page: number;
    cursor: string | null;
    column: 'EMAIL' | 'GIVEN_NAME' | 'FAMILY_NAME' | null;
    sortDirection: 'ASCENDING' | 'DESCENDING' | null;
    search: string;
  };
  setPaginationModel: Dispatch<
    SetStateAction<{
      pageSize: number;
      page: number;
      cursor: string | null;
      column: 'EMAIL' | 'GIVEN_NAME' | 'FAMILY_NAME' | null;
      sortDirection: 'ASCENDING' | 'DESCENDING' | null;
      search: string;
    }>
  >;
  setOpenMoveUserDialog: Dispatch<SetStateAction<boolean>>;
  selectedRows: string[];
  userRoles: string[];
}

export default function OrgUnitsGridToolbar({
  paginationModel,
  setPaginationModel,
  setOpenMoveUserDialog,
  selectedRows,
  userRoles,
}: UsersGridToolbarProps) {
  const queryClient = useQueryClient();

  return (
    <SharedToolbar
      quickFilterDebounceMs={300}
      noFilter
      secondaryButtons={
        <>
          <SharedIconButton
            variant="transfer"
            onClick={() => setOpenMoveUserDialog(true)}
            disabled={
              selectedRows.length === 0 ||
              !isAbleToSeeUIElement(
                userRoles,
                UserRoles.BulkSetOrganization.value
              )
            }
            tooltipLabel="Transfer"
          />
          <SharedIconButton
            variant="refresh"
            onClick={() => {
              setPaginationModel({
                page: 0,
                pageSize: paginationModel.pageSize,
                cursor: null,
                column: null,
                sortDirection: null,
                search: '',
              });
              queryClient.invalidateQueries({
                queryKey: [UserKeys.OrgUnitModels],
              });

              queryClient.invalidateQueries({
                queryKey: [UserKeys.OrgUnitUsers],
              });
            }}
            tooltipLabel="Refresh"
          />
          <SharedGridStateIconButton
            gridStateKey="orgUnitsGridStates"
            module={ModuleList.modules.directory.name}
            section={ModuleList.modules.directory.sections.organizationalUnits}
          />
        </>
      }
    />
  );
}
